<template>
  <div class="card">
    <div class="card-header">
      <!--      <h4 class="card-title pull-left">-->
      <!--        Preset Replies for Migration-->
      <!--      </h4>-->
    </div>
    <div v-if="loading" class="card-body">
      <div class="loader"></div>
    </div>
    <div v-else class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-sm btn-primary" @click="addMacro(' {firstName}')">First Name</button>
          <button class="btn btn-sm btn-primary" @click="addMacro(' {lastName}')">Last Name</button>
          <button class="btn btn-sm btn-primary" @click="addMacro(' {email}')">Email</button>
<!--          signature -->
          <button class="btn btn-sm btn-primary" @click="addMacro(' {signature}')">Signature</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <form @submit.prevent="submit">
            <label>Message:</label>
            <textarea class="form-control" required rows="3" v-model="newMacro.message"></textarea> <br>
            <button class="btn btn-sm btn-primary float-right" type="submit">{{(editIndex === -1) ? 'Submit' : 'Update'}}</button>
          </form>
        </div>
      </div>
      <section v-if="presetMacros.length > 0">
        <hr>
        <div class="row">
          <div class="col-md-8">
            <h5>Added Preset Replies</h5>
          </div>
          <div class="col-md-4">
            <button class="btn btn-primary btn-sm pull-right" @click="updateMacro">Update Sorting</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <b>Reply</b>
          </div>
          <div class="col-md-2">
            <b>Action</b>
          </div>
        </div>
        <draggable style="height: 700px; overflow: scroll" class="mt-3" v-model="$parent.presetChat" group="people" @start="drag=true" @end="drag=false">
          <div class="row macro" v-for="(macro, index) of presetMacros" :key="index">
            <div class="col-md-8">
              <span v-html="(macro.message) ? macro.message.replace(/\n/g,'<br>') : macro.replace(/\n/g,'<br>')"></span>
            </div>
            <div class="col-md-2">
              <button class="btn btn-sm btn-danger my-1" @click="deleteMacro(index)"><i class="fa fa-trash"></i></button>
              <button class="btn btn-sm btn-primary my-1" @click="editMacro(macro, index)"><i class="fa fa-pencil"></i></button>

            </div>
          </div>
        </draggable>
      </section>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {db} from "@/firebase/init";

export default {
  name: "chat",
  components: {
    draggable,
  },
  props: {
    presetMacros: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      newMacro: {
        title: '',
        message: '',
        status: '',
        priority: ''
      },
      loading: false,
      editIndex: -1
    }
  },
  methods: {
    addMacro (macro) {
      this.newMacro.message += macro
    },
    deleteMacro (index) {
      this.presetMacros.splice(index, 1)
      this.updateMacro()
    },
    editMacro (macro, index) {
      this.editIndex = index
      this.newMacro = macro
      // if (macro.title !== null && macro.title !== undefined ) {
      // } else {
      //   this.newMacro = {
      //     message: macro,
      //   }
      // }
      $('#macrosModal').show().scrollTop(0);
    },
    submit () {
      if (this.editIndex === -1) {
        this.presetMacros.push(this.newMacro)
      } else {
        this.presetMacros[this.editIndex] = this.newMacro
        this.editIndex = -1;
      }
      this.newMacro = {
        message: '',
      }
      this.updateMacro()
    },
    async updateMacro () {
      this.loading = true
      await db.collection('permissions').doc('preset_macros_chat').set({
        replies: this.presetMacros,
      })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
</style>